export const ZENDESK_BUTTON_TYPES = {
    fixed: 'fixed',
    primary: 'primary',
};
